/**
 * @generated SignedSource<<fcba87fe58c68c593345f7d8c151c08c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DirectoryAgentSeoHead_agent$data = {
  readonly address: string | null | undefined;
  readonly areas: ReadonlyArray<{
    readonly slug: string | null | undefined;
  }> | null | undefined;
  readonly googleMapsUrl: string | null | undefined;
  readonly name: string | null | undefined;
  readonly phone: string | null | undefined;
  readonly postcode: string | null | undefined;
  readonly slug: string | null | undefined;
  readonly website: string | null | undefined;
  readonly " $fragmentType": "DirectoryAgentSeoHead_agent";
};
export type DirectoryAgentSeoHead_agent$key = {
  readonly " $data"?: DirectoryAgentSeoHead_agent$data;
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryAgentSeoHead_agent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DirectoryAgentSeoHead_agent",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postcode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "website",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleMapsUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryAreaReference",
      "kind": "LinkedField",
      "name": "areas",
      "plural": true,
      "selections": [
        (v0/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "LandlordDirectoryAgent",
  "abstractKey": null
};
})();

(node as any).hash = "d6ce4c474e59f4eb2158ffdccad03cbc";

export default node;
